<template>
  <div class="flex-folders">
    <div class="flex-table d-flex flex-column">
      <div v-if="loading" class="text-center text-success my-2">
          <div class="spinner-border align-middle me-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <strong>Loading...</strong>
      </div>
      <div
        v-for="enrolment in enrolments"
        :key="enrolment.id"
        :busy="loading"
        class="flex-table-survey"
      >
        <div class="d-flex justify-content-between">
          <div
            class="flex-table-survey-info"
            @click.prevent="openCoursePage(enrolment)"
          >
            <div class="d-flex justify-content-start flex-table-row align-items-center">
              <i class="fa fa-regular fa-graduation-cap"></i>
              <div class="flex-table-title">
                {{ enrolment.course_name }}
              </div>
              <div class="pill">{{ trackLabel(enrolment.track) }}</div>
              <div class="pill">{{ enrolment.steps_done }}/{{ enrolment.steps_total }}</div>
            </div>
            <div class="d-flex pl-start-long justify-content-start flex-table-row align-items-center">
              <i class="fa fa-regular fa-calendar"></i>
              <div>Enrolled</div>
            </div>
          </div>
          <div class="ellipsis-button d-flex align-items-center">
            <BaseDropdown right variant="link">
              <template #button-content>
                <i class="fa-solid fa-ellipsis"></i>
              </template>
              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="openCoursePage(enrolment)"
                >
                  Continue
                </a>
              </li>
            </BaseDropdown>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseDropdown from "../base/BaseDropdown.vue";

export default {
  name: "LearningHubIsland",
  components: {
    BaseDropdown,
  },
  props: {
    track: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    enrolments() {
      if (this.track === "other") {
        return this.$store.state.learninghub.my.filter(
          (e) => e.track !== "certification"
        );
      }
      return this.$store.state.learninghub.my.filter(
        (e) => e.track === "certification"
      );
    },
  },
  methods: {
    trackLabel(track) {
      return track.charAt(0).toUpperCase() + track.slice(1);
    },
    openCoursePage(enrolment) {
      this.$router.push({ path: "/learninghub/" + enrolment.slug });
    },
  },
};
</script>
